export default {
  appointmentContainer: {
    title: 'Pianifichiamo la riparazione',
    text: 'I nostri riparatori sono disponibili nei seguenti slot',
    text2: 'Queste frange corrispondono al tempo di arrivo previsto del professionista',
    actions: {
      primary: 'Confermare il tempo',
      secondaryHelpText: 'Nessuno di questi slot è conveniente per te?',
      secondary: 'Vorrei essere richiamato'
    },
    dates: {
      months: {
        january: 'Gennaio',
        february: 'Febbraio',
        march: 'Marzo',
        april: 'Aprile',
        may: 'Maggio',
        june: 'Giugno',
        july: 'Luglio',
        august: 'Agosto',
        september: 'Settembre',
        october: 'Ottobre',
        november: 'Novembre',
        december: 'Dicembre'
      }
    },
    notifications: {
      errors: {
        getSchedule: 'Errore! Non è stato possibile recuperare i giorni disponibili per l’appuntamento.',
        postAppointment: 'Errore! L’appuntamento selezionato non può essere programmato.',
        postContact: 'Errore! Il contatto non può essere richiesto.'
      }
    }
  }
}
